/* The rules behind /u1/plans, transcribed from components/public/Payment/PaymentPlans.jsx. */

import {
  PLAN_MONTHLY,
  PLAN_YEARLY,
  PROFILE_WINDOW_DAYS,
} from "../../../../constants/webProfilePricing";
import { readJson } from "./paymentDetailsFields";

/* What a Web Profile buys, and what Membership adds on top. Both lists are
   transcribed word for word. */
export const PROFILE_FEATURES = [
  "Identity, registration, signatures",
  "Banking footprint and recent filings",
  `${PROFILE_WINDOW_DAYS} days of live updates inside the window`,
];

export const MEMBERSHIP_FEATURES = [
  "Web Profile at the Member rate (10% off)",
  "Payment Endorsements and the Partner Program",
  "Path to the Verified Member badge",
];

/* Which company is being bought. Route state first, then the id stashed by
   whichever screen sent the user here. */
export const resolveTargetCompanyId = (state) =>
  state?.company_id || readJson("payasyougoCompanyID");

/* Membership is bought BY A BUSINESS, not by a person — the same rule the Membership screen states in its empty state. */
export const canJoinMembership = (activeCompanyId) => Boolean(activeCompanyId);

/* Transcribed: only these two statuses get the member rate. */
export const isMemberStatus = (status) => ["member", "verified"].includes(status);

/* TIP-493 (W3) — the cached active company's status can be stale, so the
   freshly fetched one wins and the cache is the fallback. */
export const actingStatusOf = (fetched, cached) =>
  fetched?.profile_status || cached?.profile_status;

/* A member never pays the standard rate, whatever the cards are showing: the member branch is applied over the chosen mode, not instead of it. */
export const effectiveModeOf = (isMember, mode, canJoin = true) => {
  if (isMember) return "member";
  if (!canJoin && mode === "bundle") return "payg";
  return mode;
};

/* The line under the heading. A member is told the rate is already theirs;
   everyone else is told there is a cheaper way. */
export const introCopy = (isMember, canJoin = true) => {
  if (isMember) return "Your Member rate is applied automatically.";
  /* Do not offer the Member rate to someone who cannot reach it — the sentence
     would be pointing at a card that is greyed out. */
  if (!canJoin) return "Pay the standard rate for this profile.";
  return "Pay the standard rate, or take the Member rate by joining Membership.";
};

/* The upsell panel is for a non-member who has the standard card selected — there is nothing to offer a member, and the bundle card IS the offer. */
export const showsUpsell = (isMember, mode, canJoin = true) =>
  !isMember && mode === "payg" && canJoin;

export const membershipTermLabel = (plan) =>
  plan === PLAN_YEARLY
    ? "Annual Membership · two months free"
    : "Monthly Membership";

export const membershipTermSuffix = (plan) =>
  plan === PLAN_YEARLY ? "year" : "month";

/* Where Continue goes. Transcribed: signed in, the choice is handed to the payment step; signed out, /plans is remembered so login can come back here rather... */
export const continueTarget = ({ token, mode, plan, companyId }) =>
  token
    ? {
        to: "/plans/paymentdetails",
        options: { state: { planDetails: { mode, plan }, company_id: companyId } },
      }
    : { to: "/login", remember: "/plans" };

export { PLAN_MONTHLY, PLAN_YEARLY };
